/**
 * Whether a route's `:id` segment can address an entity at all.
 *
 * The id-driven detail routes (`products/:id/:name`, `solutions/:id/:name`)
 * resolve entirely from the id and ignore the slug, so `/products/products/x`
 * is not a duplicated route registration — it is `/products/:id/:name` with
 * `id = "products"`. `+id` turns that into `NaN`, which used to be sent to the
 * backend as a lookup and came back as an error the routes never handled: the
 * page rendered an empty shell, answered 200 and self-canonicalized, so
 * Prerender.io cached a non-existent page as valid (SIIL-6166).
 *
 * Shared by both detail routes so they cannot drift on what counts as
 * addressable. Deliberately strict — digits only. A blank, absent, signed or
 * decimal segment is not an id, and neither is a slug.
 */
export function isNumericRouteId(rawId: string | null | undefined): boolean {
  return rawId != null && /^\d+$/.test(rawId);
}
